<div
  class="h-px -mb-px"
  siatStickyObserver
  (stickyChange)="onSticky($event)"
></div>
<mat-card-title
  class="sticky! top-16! z-900! py-2! -mx-3! px-3! block! transition-all duration-500 ease-in-out"
  [ngClass]="{ 'bg-white!': isSticky() }"
  [style.border-bottom]="
    isSticky() ? '2px solid #d1d5db' : '2px solid transparent'
  "
  [style.border-radius]="isSticky() ? '0 0 16px 16px' : '0'"
>
  <div
    class="flex flex-col gap-3 sm:flex-row sm:justify-between sm:items-center"
  >
    <h2 class="text-xl mb-0 mt-0 font-medium flex items-center gap-2">
      @if (isSticky()) {
        <mat-icon
          class="text-gray-400"
          matTooltip="Gestione sezione"
          [attr.aria-label]="'Gestione sezione'"
          >settings</mat-icon
        >
      }
      Sezione {{ sectionIndex }}
    </h2>
    <div>
      <button
        [class.active]="dragFieldsEnabled"
        [disabled]="fieldsArray?.controls?.length <= 1"
        [attr.aria-label]="
          dragFieldsEnabled ? 'Salva posizioni domande' : 'Riposiziona domande'
        "
        type="button"
        class="section-icon-button"
        matIconButton
        (click)="toggleDragFields()"
        [matTooltip]="
          dragFieldsEnabled ? 'Salva posizioni domande' : 'Riposiziona domande'
        "
      >
        @if (dragFieldsEnabled) {
          <mat-icon>save</mat-icon>
        } @else {
          <mat-icon>move_up</mat-icon>
        }
      </button>
      <button
        [attr.aria-label]="'Aggiungi domanda'"
        type="button"
        mat-icon-button
        class="section-icon-button"
        (click)="addFieldToSection()"
        matTooltip="Aggiungi domanda"
      >
        <mat-icon>add</mat-icon>
      </button>
      <button
        [attr.aria-label]="'Elimina sezione'"
        type="button"
        mat-icon-button
        class="section-icon-button"
        (click)="deleteSection.emit(sectionId)"
        matTooltip="Elimina sezione"
        [disabled]="disableDeleteSection"
      >
        <mat-icon class="material-icons-outlined">delete</mat-icon>
      </button>
    </div>
  </div>
  <hr class="mt-0" />
</mat-card-title>
<mat-card-content
  class="p-0!"
  cdkDropList
  (cdkDropListDropped)="onFieldDropped($event)"
  [cdkDropListDisabled]="!dragFieldsEnabled"
>
  <div>
    <siat-input-field
      [formGroup]="sectionForm"
      [controlName]="'title'"
      appearance="outline"
      [id]="sectionId + '_title'"
      [placeholder]="'Inserisci il titolo della sezione ' + sectionIndex"
      [label]="'Titolo sezione ' + sectionIndex"
      type="text"
      class="w-full"
    ></siat-input-field>
  </div>
  <div class="mt-3">
    <siat-textarea-field
      [formGroup]="sectionForm"
      [controlName]="'description'"
      [rows]="4"
      appearance="outline"
      [id]="sectionId + '_description'"
      [placeholder]="'Inserisci la descrizione della sezione ' + sectionIndex"
      [label]="'Descrizione sezione ' + sectionIndex"
      type="text"
      class="w-full"
    ></siat-textarea-field>
  </div>
  @for (
    fieldCtrl of fieldsArray.controls;
    track trackByFn($index, fieldCtrl);
    let i = $index
  ) {
    <mat-card
      cdkDrag
      [cdkDragData]="fieldCtrl"
      [cdkDragDisabled]="!dragFieldsEnabled"
      class="mb-2 mt-4 px-3 pb-3"
      appearance="outlined"
      [class.selected]="dragFieldsEnabled"
    >
      <siat-field-builder
        [fieldIndex]="i + 1"
        [sectionIndex]="sectionIndex"
        [fieldId]="fieldCtrl?.getRawValue()?.id"
        [fieldForm]="getFieldFormGroup(fieldCtrl)"
        [dragFieldsEnabled]="dragFieldsEnabled"
        (duplicate)="duplicateField(getFieldFormGroup(fieldCtrl))"
        (delete)="deleteField(getFieldFormGroup(fieldCtrl))"
      />
    </mat-card>
  }
</mat-card-content>
